import { useState, useCallback } from 'react';

export const useProcessForm = (initialState = {}) => {
  const [formContext, setFormContext] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);

  const updateFormContext = useCallback((newData) => {
    setFormContext((prevContext) => ({ ...prevContext, ...newData }));
  }, []);

  const resetForm = useCallback(() => {
    setFormContext(initialState);
    setIsLoading(false);
  }, [initialState]);

  return {
    formContext,
    setFormContext,
    updateFormContext,
    isLoading,
    setIsLoading,
    resetForm,
  };
};
